import { useHubLastVisited } from './use-hub-last-visited';
import { useMemo } from 'react';
import { useUnseenAlerts } from './use-unseen-alerts';

const shouldShowAlertsIndicator = (
  unseenAlerts: number | null,
  unseenAlertsLoading: boolean,
  lastHubViewed: string | null,
  lastHubViewedLoading: boolean,
) => {
  // if loading unseen alerts or last hub viewed, don't show the indicator
  if (unseenAlertsLoading || lastHubViewedLoading) {
    return false;
  }

  // if Hub was never viewed or have an error fetching alerts, show the indicator
  if (lastHubViewed === null || unseenAlerts === null) {
    return true;
  }

  return unseenAlerts > 0;
};

export const useUnseenAlertsIndicator = () => {
  const { lastVisitedAt, lastVisitedLoading } = useHubLastVisited();
  const { unseenAlertsData, unseenAlertsLoading, refetchUnseenAlerts } =
    useUnseenAlerts();

  return useMemo(
    () => ({
      refetchUnseenAlerts,
      showAlertsIndicator: shouldShowAlertsIndicator(
        unseenAlertsData,
        unseenAlertsLoading,
        lastVisitedAt,
        lastVisitedLoading,
      ),
    }),
    [
      refetchUnseenAlerts,
      unseenAlertsData,
      unseenAlertsLoading,
      lastVisitedAt,
      lastVisitedLoading,
    ],
  );
};
